import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { RecoilRoot } from "recoil";

import { AuthProvider } from "./contexts/AuthContext";
import RoutesApp from "./routes";

import "react-toastify/dist/ReactToastify.css";

function App() {
    return (
        <div className="App">
            <RecoilRoot>
                <BrowserRouter>
                    <AuthProvider>
                        <ToastContainer autoClose={3000} />
                        <RoutesApp />
                    </AuthProvider>
                </BrowserRouter>
            </RecoilRoot>
        </div>
    );
}

export default App;
